export default "__VITE_ASSET__CbvV$Ir0__"